import { Table, Label, Icon } from 'semantic-ui-react';
import DownloadableFile from './DownloadableFile';
import { InputWithLabelWrapper } from 'react-lib/dist/components-es';
import ButtonWrapper from '@components/common/ButtonWrapper';
import { useState } from 'react';
import useUser from '@behavior/init/getUserV2';
import { EDIT_MODE } from 'constants';
import { useTranslation } from 'react-i18next';
import { CREATE_MODE } from 'constants';
import { CLONE_MODE } from 'constants';

function NewTableFileViewerWrapper({ mode, disabled, ...props }) {
  const [removedFileIndices, setRemovedFileIndices] = useState([]);
  const { user } = useUser();
  const { t } = useTranslation();

  const getObjPropRecursively = (obj, props) => {
    let result = obj;
    if (props && obj) {
      const propsPath = props.split('.');
      propsPath.forEach(subProp => {
        result = result != null && result.hasOwnProperty(subProp) ? result[subProp] : null;
      });
    }
    return result;
  };

  const getUploadedFilesTable = () => {
    const { value, filesHeaderIcon } = props;

    return (
      <Table basic className="reducedWhiteSpaceTableHeader">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              {filesHeaderIcon && <Icon name={filesHeaderIcon} size="small" />}
              <InputWithLabelWrapper label="file_input_file_name" fieldClassName="inlineBlock" />
            </Table.HeaderCell>
            {getExtraColumnsHeaders()}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {value.map((f, index) => {
            return getUploadedFileRow(f, index);
          })}
        </Table.Body>
      </Table>
    );
  };

  const getExtraColumnsHeaders = () => {
    const { extraColumns } = props;

    return (
      extraColumns &&
      extraColumns.map(c => (
        <Table.HeaderCell key={`tableFileViewerWrapperHeader-${c.label}`}>
          <InputWithLabelWrapper label={c && c.label ? t(c.label) : null} />
        </Table.HeaderCell>
      ))
    );
  };

  const removeFile = index => {
    const { value } = props;
    const fileDataProp = getObjPropRecursively(value[index], props.fileDataProp);

    if (fileDataProp) {
      fileDataProp.delUser = user;
      fileDataProp.deleted = true;
    }
    setRemovedFileIndices([...removedFileIndices, index]);
  };

  const getDownloadFileCell = (f, index) => {
    const { fileDataProp } = props;
    const fileData = getObjPropRecursively(f, fileDataProp);

    return (
      <Table.Cell className="tableCellOption">
        <DownloadableFile fileName={fileData.name} uploadId={fileData.id} />
        {(mode == EDIT_MODE || mode == CREATE_MODE || mode == CLONE_MODE) && (
          <ButtonWrapper
            icon="remove"
            color="red"
            disabled={disabled}
            onClick={() => removeFile(index)}
          />
        )}
      </Table.Cell>
    );
  };

  const getExtraColumnsCells = (f, index) => {
    const { extraColumns } = props;
    return (
      extraColumns &&
      extraColumns.map(c => (
        <Table.Cell
          className="tableCellOption"
          width={c.width}
          key={`tableFileViewerWrapperCell-${c.label}-${index}`}
        >
          {c.render({ ...props, f, fIndex: index })}
        </Table.Cell>
      ))
    );
  };

  const getUploadedFileRow = (f, index) => {
    const { hideFile } = props;
    return (
      <Table.Row key={index} hidden={hideFile(f)}>
        {getDownloadFileCell(f, index)}
        {getExtraColumnsCells(f, index)}
      </Table.Row>
    );
  };

  return getUploadedFilesTable();
}

export default NewTableFileViewerWrapper;
